const REVIEW_CHOICES = [
  { label: 'Keep', sendText: 'keep' },
  { label: 'Remove', sendText: 'remove' },
  { label: 'Edit', sendText: 'edit' },
];

const REVIEW_WITH_ALL_KEEP_CHOICES = [
  { label: 'Keep', sendText: 'keep' },
  { label: 'Remove', sendText: 'remove' },
  { label: 'Edit', sendText: 'edit' },
  { label: 'All correct', sendText: 'all correct' },
];

const YES_NO_CHOICES = [
  { label: 'Yes', sendText: 'yes' },
  { label: 'No', sendText: 'no' },
];

const ADD_NO_CHOICES = [
  { label: 'Add', sendText: 'add' },
  { label: 'No', sendText: 'no' },
];

/**
 * Return constrained choices for the current conversation state.
 * Returns null when free text should remain available.
 */
export function getConstrainedChoices(state) {
  const {
    step,
    phase,
    medicationsCount,
    waitingForEditConfirm,
    waitingForAllergyEditConfirm,
    waitingForPmhEditConfirm,
    waitingForPshEditConfirm,
    waitingForAddConfirm,
    waitingForAllergyAddConfirm,
    waitingForPmhAddConfirm,
    waitingForPshAddConfirm,
  } = state;

  if (step === 'review') {
    if (phase === 'medications') {
      if (waitingForEditConfirm) return YES_NO_CHOICES;
      if (medicationsCount > 1) return REVIEW_WITH_ALL_KEEP_CHOICES;
      return REVIEW_CHOICES;
    }
    if (phase === 'allergies') {
      if (waitingForAllergyEditConfirm) return YES_NO_CHOICES;
      return REVIEW_CHOICES;
    }
    if (phase === 'pmh') {
      if (waitingForPmhEditConfirm) return YES_NO_CHOICES;
      return REVIEW_CHOICES;
    }
    if (phase === 'psh') {
      if (waitingForPshEditConfirm) return YES_NO_CHOICES;
      return REVIEW_CHOICES;
    }
  }

  if (step === 'add_prompt') return ADD_NO_CHOICES;
  if (step === 'offer_next_section') return YES_NO_CHOICES;
  if (step === 'other_confirm') return YES_NO_CHOICES;

  if (step === 'adding_medication' && waitingForAddConfirm) return YES_NO_CHOICES;
  if (step === 'adding_allergy' && waitingForAllergyAddConfirm) return YES_NO_CHOICES;
  if (step === 'adding_pmh' && waitingForPmhAddConfirm) return YES_NO_CHOICES;
  if (step === 'adding_psh' && waitingForPshAddConfirm) return YES_NO_CHOICES;

  return null;
}
